import { GiOpenFolder } from "react-icons/gi";
import { BiLink } from "react-icons/bi";
import { useEffect, useState } from "react";
import AnimatedTitle from "../../../components/AnimatedTitle";
import AnimatedBox from "../../../components/AnimatedBox";

const boxData = [
  {
    text: "Efforless Integration",
    icon: GiOpenFolder,
    line: "Deploy solutions in record-breaking time easily. Deploy solutions in record",
  },
  {
    text: "No Custom Code",
    icon: BiLink,
    line: "Deploy solutions in record-breaking time easily. Deploy solutions in record",
  },
];

function SimplifySection() {
  const [isNotLg, setIsNotLg] = useState(window.innerWidth < 1024);

  useEffect(() => {
    const handleResize = () => {
      setIsNotLg(window.innerWidth < 1024);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const style = document.createElement("style");
    style.textContent = `
      .hover-container {
        position: relative;
      }
      .hover-container .transition-opacity:first-child {
        opacity: 1;
        z-index: 2;
        transition: opacity 1000ms ease-in-out;
      }
      .hover-container .transition-opacity:last-child {
        opacity: 0;
        z-index: 1;
        transition: opacity 1000ms ease-in-out;
      }
      .hover-container:hover .transition-opacity:first-child {
        opacity: 0;
        z-index: 1;
      }
      .hover-container:hover .transition-opacity:last-child {
        opacity: 1;
        z-index: 2;
      }
    `;
    document.head.appendChild(style);
    return () => document.head.removeChild(style);
  }, []);

  return (
    <section className="flex items-center justify-center pt-24 pb-40">
      <div className="container mx-auto px-4 md:px-6 lg:px-8 text-center">
        <AnimatedTitle
          className="text-3xl font-semibold mb-10"
          style={{
            color: "var(--color-primary)",
            maxWidth: "85%",
            marginLeft: "auto",
            marginRight: "auto",
          }}
        >
          Simplify Complex Data Integration
        </AnimatedTitle>

        <AnimatedBox>
          <div className="flex flex-col md:flex-row justify-center items-center gap-6">
            {isNotLg
              ? boxData.map((box, idx) => {
                  const Icon = box.icon;
                  return (
                    <div
                      key={`front-${idx}`}
                      className="flex items-center justify-between px-6 py-4 rounded-2xl transition-opacity"
                      style={{
                        width: "320px",
                        backgroundImage: "url(/box2.png)",
                        backgroundSize: "cover",
                      }}
                    >
                      <span className="text-white font-semibold text-3xl text-left">
                        {box.text}
                      </span>
                      <Icon
                        className="text-9xl"
                        style={{
                          color: "var(--color-third)",
                          animation: "pulseEffect 1s ease-in-out infinite",
                        }}
                      />

                      <style>
                        {`
      @keyframes pulseEffect {
        0%, 100% { transform: scale(1); }
        50% { transform: scale(1.1); }
      }
    `}
                      </style>
                    </div>
                  );
                })
              : boxData.map((box, idx) => {
                  const Icon = box.icon;
                  return (
                    <div
                      key={`container-${idx}`}
                      style={{ position: "relative" }}
                      className="hover-container"
                    >
                      <div
                        key={`front-${idx}`}
                        className="flex items-center justify-between px-6 py-4 rounded-2xl transition-opacity"
                        style={{
                          width: "320px",
                          backgroundImage: "url(/box2.png)",
                          backgroundSize: "cover",
                        }}
                      >
                        <span className="text-white font-semibold text-3xl text-left">
                          {box.text}
                        </span>
                        <Icon
                          className="text-9xl"
                          style={{
                            color: "var(--color-third)",
                            animation: "pulseEffect 1s ease-in-out infinite",
                          }}
                        />

                        <style>
                          {`
      @keyframes pulseEffect {
        0%, 100% { transform: scale(1); }
        50% { transform: scale(1.1); }
      }
    `}
                        </style>
                      </div>
                      <div
                        key={`back-${idx}`}
                        className="flex flex-col items-center justify-between px-6 py-4 rounded-2xl transition-opacity"
                        style={{
                          width: "320px",
                          backgroundImage: "url(/box2.png)",
                          backgroundSize: "cover",
                          position: "absolute",
                          top: "0",
                        }}
                      >
                        <Icon
                          className="text-9xl"
                          style={{
                            color: "var(--color-third)",
                            animation: "pulseEffect 1s ease-in-out infinite",
                          }}
                        />

                        <style>
                          {`
      @keyframes pulseEffect {
        0%, 100% { transform: scale(1); }
        50% { transform: scale(1.1); }
      }
    `}
                        </style>
                        <span className="text-white font-semibold text-xl text-left w-full">
                          {box.text}
                        </span>
                        <span className="text-white text-xs text-left w-full">
                          {box.line}
                        </span>
                      </div>
                    </div>
                  );
                })}
          </div>
        </AnimatedBox>
      </div>
    </section>
  );
}

export default SimplifySection;
